import { render } from "./receiptDiscount.vue?vue&type=template&id=32368908&scoped=true"
import script from "./receiptDiscount.vue?vue&type=script&lang=js"
export * from "./receiptDiscount.vue?vue&type=script&lang=js"

import "./receiptDiscount.vue?vue&type=style&index=0&id=32368908&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32368908"]])

export default __exports__